import { ChevronRight as IconChevronRight } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { Link, To } from "react-router";

type CarpoolHeaderProps = {
    label: string;
    openHref: () => To;
};

export function CarpoolHeader({ label, openHref }: CarpoolHeaderProps) {
    return (
        <Stack
            direction="row"
            paddingBlock={0.5}
            paddingInline={2}
            alignItems="center"
            justifyContent="space-between"
            sx={theme => ({ borderBottom: `1px solid ${theme.palette.divider}` })}
        >
            <Typography variant="overline">{label}</Typography>
            <IconButton size="small" component={Link} to={openHref()}>
                <IconChevronRight fontSize="small" />
            </IconButton>
        </Stack>
    );
}
